import { useState, useCallback } from "react";
import { getFilePreviews, handleDropUtil } from "../../utils";

export const useFilePreviews = () => {
    const [previews, setPreviews] = useState([]);

    const handleAttachFile = useCallback((files) => {
        const newFiles = Array.from(files).filter(
            file => !previews.some(
                prev => prev.name === file.name && prev.type === file.type
            )
        );
        if (newFiles.length === 0) return;

        getFilePreviews(newFiles).then(newPreviews => {
            setPreviews(prev => [...prev, ...newPreviews]);
        });
    }, [previews]);

    const handleDrop = useCallback((e) => {
        handleDropUtil(e, handleAttachFile);
    }, [handleAttachFile]);

    return { previews, setPreviews, handleDrop, handleAttachFile };
};